class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const card = this.closest('product-card');
    const img = card ? card.querySelector('product-card-media-gallery img') : null;
    const newSrc = swatch.dataset.image;

    // Pas de photo associée à cette couleur : comportement d'origine (ouvre la fiche)
    if (!img || !newSrc) {
      window.location.href = swatch.dataset.href;
      return;
    }

    // Change la photo de la carte sans quitter la page
    img.src = newSrc;
    if (swatch.dataset.srcset) {
      img.srcset = swatch.dataset.srcset;
    } else {
      img.removeAttribute('srcset');
    }

    // Met la pastille choisie en surbrillance
    this.querySelectorAll('[data-href]').forEach((s) => s.removeAttribute('aria-checked'));
    swatch.setAttribute('aria-checked', 'true');

    // Un clic sur la carte ouvre ensuite la fiche sur cette couleur
    if (card) {
      card.dataset.productUrl = swatch.dataset.href;
      card.productUrl = swatch.dataset.href;
    }
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}